import { FairtransportMembershipType } from '../types';
import { FAIRTRANSPORT_MEMBERSHIP_TYPES } from '../types/FairtransportMembershipType';

type CustomItemListType = {
    id: string;
    value: string;
}[];

type Props = {
    key: string;
    array: string[];
    value: string;
    entity: { [key: string]: any };
    onChange: (e: any) => void;
};

export const cleanEntityMetadata = (entity: { [key: string]: any }) => ({
    ...entity,
    vehicles: (entity.vehicleTypes || []).filter((veh: string) => veh && veh.trim()),
    equipment: (entity.equipment || []).filter((eq: string) => eq && eq.trim()),
    sustainability: (entity.sustainability || []).filter((sust: string) => sust && sust.trim()),
    licencesCertificates: (entity.licencesCertificates || []).filter((cert: string) => cert && cert.trim()),
    customLicencesCertificates: (entity.customLicencesCertificates || []).filter((cert: string) => cert && cert.trim()),
    sniIndustries: (entity.sniIndustries || []).filter((sni: string) => sni && sni.split(' ')[0]),
    industries: (entity.industries || []).filter((ind: string) => ind && ind.trim())
});

export const hasStandardProperty = (
    { array, value }
        : { array: string[], value: string }
) => {
    return array && array.includes(value);
};

export const isInputAlreadyInList = ({
    id,
    value,
    list
}: {
    id: string | number,
    value: string
    list: CustomItemListType
}) => {
    const firstMatch = list.find(
        (i) => i.value.toLowerCase().trim() === value.toLowerCase().trim() && value !== ''
    );

    return !!firstMatch && firstMatch.id !== id;
};

export const isCustomCertInPresets = ({
    value,
    presets
}: {
    value: string,
    presets: string[]
}) => {
    if (!value.trim()) {
        return false;
    }
    return presets.some((cert: string) => cert.toLowerCase() === value.toLowerCase().trim());
};

export const isFairtransportMember = (membership: FairtransportMembershipType) => {
    const membershipValues = Object.values(FAIRTRANSPORT_MEMBERSHIP_TYPES);
    if (!membership) {
        return false;
    }
    return membershipValues.includes(membership);
};

export const fairtransportMembershipOptions = [
    { value: FAIRTRANSPORT_MEMBERSHIP_TYPES.MEMBER, label: 'Medlem' },
    { value: FAIRTRANSPORT_MEMBERSHIP_TYPES.VALUELEVEL1, label: 'Medlem (mervärdesnivå 1)' },
    { value: FAIRTRANSPORT_MEMBERSHIP_TYPES.VALUELEVEL2, label: 'Medlem (mervärdesnivå 2)' },
    { value: FAIRTRANSPORT_MEMBERSHIP_TYPES.VALUELEVEL3, label: 'Medlem (mervärdesnivå 3)' }
];

export const changeStandardProperty = (
    {
        key,
        array,
        value,
        entity,
        onChange
    }: Props
) => {
    const createUpdatedArray = () => {
        if (array && array.includes(value)) {
            return array.filter((i) => i !== value);
        }
        return [...(array || []), value];
    };
    onChange({
        ...entity,
        [key]: createUpdatedArray()
    });
};
